import { render, staticRenderFns } from "./DeliveryPersistView.vue?vue&type=template&id=72b05ca2"
import script from "./DeliveryPersistView.vue?vue&type=script&lang=ts"
export * from "./DeliveryPersistView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports